import React from 'react'
import { useTheme } from '@/contexts/ThemeContext'

export const ThemeToggle: React.FC = () => {
  const { theme, setTheme, colorScheme } = useTheme()

  const themes = [
    { id: 'light', label: 'Light', icon: '☀️', description: 'Light mode' },
    { id: 'dark', label: 'Dark', icon: '🌙', description: 'Dark mode' },
    { id: 'auto', label: 'Auto', icon: '🔄', description: 'System preference' }
  ] as const

  return (
    <div className="flex items-center space-x-2">
      {/* Quick Toggle Button */}
      <button
        onClick={() => setTheme(colorScheme === 'dark' ? 'light' : 'dark')}
        className="relative inline-flex h-8 w-14 items-center rounded-full bg-gray-200 dark:bg-gray-700 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background hover:bg-gray-300 dark:hover:bg-gray-600"
        title={`Switch to ${colorScheme === 'dark' ? 'light' : 'dark'} mode`}
      >
        <span
          className={`inline-block h-6 w-6 transform rounded-full bg-white shadow-lg transition-transform duration-200 ease-in-out ${
            colorScheme === 'dark' ? 'translate-x-7' : 'translate-x-1'
          }`}
        >
          <span className="flex h-full w-full items-center justify-center text-xs">
            {colorScheme === 'dark' ? '🌙' : '☀️'}
          </span>
        </span>
      </button>

      {/* Theme Selector Dropdown */}
      <div className="relative group">
        <button
          className="flex items-center space-x-1 px-3 py-1 bg-background/50 border border-border rounded-lg text-foreground hover:bg-background/80 transition-colors focus:outline-none focus:ring-2 focus:ring-primary"
          title="Theme options"
        >
          <span className="text-sm">
            {themes.find(t => t.id === theme)?.icon || '🎨'}
          </span>
          <span className="text-xs font-medium">
            {themes.find(t => t.id === theme)?.label || 'Theme'}
          </span>
          <span className="text-xs">▼</span>
        </button>

        {/* Dropdown Menu */}
        <div className="absolute right-0 mt-2 w-48 bg-card border border-border rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
          <div className="py-1">
            {themes.map((themeOption) => (
              <button
                key={themeOption.id}
                onClick={() => setTheme(themeOption.id)}
                className={`w-full flex items-center space-x-3 px-4 py-2 text-sm transition-colors ${
                  theme === themeOption.id
                    ? 'bg-primary text-primary-foreground'
                    : 'text-foreground hover:bg-muted'
                }`}
              >
                <span className="text-lg">{themeOption.icon}</span>
                <div className="flex-1 text-left">
                  <div className="font-medium">{themeOption.label}</div>
                  <div className="text-xs opacity-75">{themeOption.description}</div>
                </div>
                {theme === themeOption.id && (
                  <span className="text-primary-foreground">✓</span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
